export enum OrderQueries {
	GET_ORDERS = `
    query Orders ($where: OrderListItemFilterInput, $first: Int, $after: String) {
        orders(
            where: $where,
            first: $first,
            after: $after,
            order: { creationDate: DESC }
        ) {
            nodes {
                photographerPersonId
                photographerFullName
                orderId
                orderNumber
                orderStatusId
                orderStatusName
                dueDate
                creationDate
                completionDate
                finalCost
                totalShipped
                totalOrdered
             
                warehouse {
                    id
                    code
                    description
                    address
                }
                orderType {
                    id
                    name
                }
                waybill{
                    waybillNumber
                    waybillUrl
                    shippingDate
                }
            }
            totalCount
        }
    }
    `,
	GET_PHOTOGRAPHER_DASHBOARD_RESUME = `
    query PhotographerDashboardResume($photographerId: [Int!]) {
        draft: orders(
            where: {
                photographerPersonId: { in: $photographerId }
                orderStatusId: { eq: 1 }
            }
        ) {
            totalCount
        }
        readyForPickup: orders(
            where: {
                photographerPersonId: { in: $photographerId }
                orderStatusId: { eq: 3 }
            }
        ) {
            totalCount
        }
        inProgress: orders(
            where: {
                photographerPersonId: { in: $photographerId }
                orderStatusId: { eq: 4 }
            }
        ) {
            totalCount
        }
        shootCompleted: orders(
            where: {
                photographerPersonId: { in: $photographerId }
                orderStatusId: { eq: 5 }
            }
        ) {
            totalCount
        }
        approved: orders(
            where: {
                photographerPersonId: { in: $photographerId }
                orderStatusId: { eq: 6 }
            }
        ) {
            totalCount
        }
        rejected: orders(
            where: {
                photographerPersonId: { in: $photographerId }
                orderStatusId: { eq: 7 }
            }
        ) {
            totalCount
        }
    }
    `,

	GET_ORDER_DETAILS = `
    query OrderDetails($orderId: Int!, $where: OrderDetailFilterInput, $first: Int, $after: String) {
        orderDetails(orderId: $orderId, where: $where, first: $first, after: $after) {
            nodes {
                style{
                    brand {
                        id
                        name
                    }
                    category {
                        id
                        name
                    }
                    currentStyleStatus {
                        styleStatus {
                            id
                            name
                        }
                    }
                    styleGroup {
                        id
                        name
                    }
                    styleDescription {
                        id
                        name
                    }
                    purpose {
                        id
                        name
                    }
                    schema {
                        schemaTeamColors {
                            team {
                                id
                                code
                                name
                                cancelled
                                active
                            }
                            color {
                                id
                                code
                                name
                                colorCardId
                                autoGeneratedColorName
                                finalColorName
                            }
                        }
                        collection {
                            id
                            name
                        }
                    }
                    modelId
                    code
                    name
                    warehouseArticles {
                        id
                        availableQty
                        warehouse{
                            id
                            description
                        }
                        color{
                            id
                            code
                            name
                        }
                        size {
                            id
                            name
                        }
                    }
                }
                colorsSizeGroups {
                    modelId
                    orderStyleId
                    colorId
                    colorName
                    sizeGroupId
                    sizeGroupName
                     
                    isAi
                    size{
                        id
                        label
                    }
                    shots {
                        shotId
                        estimatedFileName
                        imgPath
                        mandatory
                        shotApprovalStatusId
                        shotType {
                            id
                            label
                        }
                        aspectRatio {
                            id
                            label
                        }
                        mediaFormat {
                            id
                            label
                        }
                        codifiedUse {
                            id
                            label
                        }
                    }
                     
                }
                    warehouse {
                        id
                        code
                        description
                    }
                    
            }
                totalCount
        }
    }
    `,
	GET_ORDER_STATUSES = `
    query OrderStatus {
        orderStatus  {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
	GET_ORDER_TYPES = `
    query OrderTypes {
        orderTypes {
            totalCount
            nodes {
                id
                name
            }
        }
    }
    `,
	GET_WAREHOUSES_NO_IDS = `
    query Warehouses($first: Int, $after: String, $search: String) {
        warehouses(
            first: $first, after: $after, 
            
            where: { or: [{code: { contains: $search }}, {description: { contains: $search }}]
            }
            order: { code: ASC, description: ASC }
        ) {
            nodes {
                code
                description
                id
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
	GET_SHOTS = `
    query Shots($requestShots: [RequestShotsTemplateInput!]!) {
        shots(
            requestShots: $requestShots
        )  

        {
         
        nodes {
            modelId
            styleCode
            styleName
            sizeGroupId
            sizeGroupName
            colors {
                colorId
                colorName
                defaultColor
                shots {
                    shotId
                    imgPath
                    mandatory
                    shotApprovalStatusId
                    estimatedFileName
                    shotType {
                        id
                        label
                    }
                    aspectRatio {
                        id
                        label
                    }
                    mediaFormat {
                        id
                        label
                    }
                    codifiedUse {
                        id
                        label
                    }
                }
            }
        }
    }
    }
    `,
	DELETE_IMAGES_BY_ORDER_ID = `
        mutation DeleteImageByOrderId($OrderId: Int!) {
            deleteImageByOrderId(deleteImageByOrderIdInput: { orderId: $OrderId, cancelApproved: false }) {
                success
            }
        }
    `,
	GET_ORDER_FILENAMES = `
    query OrderFilenames($orderId: Int!) {
        orderFilenames(orderId: $orderId) 
    }
    `,

	GET_ORDERED_SKUS = `
    query OrderedSkus($orderId: Int!) {
        orderedSkus(orderId: $orderId)
    }
    `,
	GET_SHIPPED_SKUS = `
    query ShippedSkus($orderId: Int!) {
        shippedSkus(orderId: $orderId)
    }
    `,

	GET_ORDER_RESUME = `
        query OrderShotsResume($orderId: Int!) {
            orderShotsResume(orderId: $orderId) {
                requiredShots
                approvedShots
                rejectedShots
                uploadedShots
                missingShots 
                totalSku
                finalCost
            }
    }
    `,
	UPDATE_SHOT_STATUS_BY_ORDER_ID = `
        mutation UpdateShotStatusByOrderId($updateShotStatusByOrderIdInput: UpdateShotStatusByOrderIdInput) {
            updateShotStatusByOrderId(updateShotStatusByOrderIdInput: $updateShotStatusByOrderIdInput) {
                success
                message
            }
        }
    `,

	GET_STYLE_RESUME = `
        query StyleShotsResume($modelId: Int!) {
            styleShotsResume(modelId: $modelId) {
                requiredShots
                approvedShots
                rejectedShots
                uploadedShots
                missingShots
            }
    }
    `,

	GET_SELECTED_SIZES = `
    query Orders($orderId: Int!) {
        orderSelectedSizes(orderId: $orderId) {
            modelId
            brand {
                id
                label
            }
            category {
                id
                label
            }
            colors {
                id
                label
                sizes {
                    id
                    label
                    ean
                }
            }
        }   
    }
    `,

	CHECK_ORDER_COST_CHANGES = `
    query CheckOrderCostChanges {
        checkOrderCostChanges {
            orderId
            creationDate
            status {
                id
                label
            }
            beforeCost
            afterCost
        }
    }
    `
}
